var dd = require('react-dd');


var ErrorAlert = dd.createClass({
	render: function(){
		if(!this.props.message){
			return dd.div();
		}
		return dd.div({className: 'alert alert-danger'},
			this.props.message
		);
	}
});

module.exports = ErrorAlert;



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/ErrorAlert.js
// module id = 7
// module chunks = 0 1 2 3 4